import request from '../request'
//查询领款汇总记录
export function receive_money_list(params,data) {
    return request({
        url: "/summary/receive_money/list",
        method: "post",
        params,
        data
    })  
}
//费用报销汇总记录
export function cost_apply_list(params,data) {
    return request({
        url: "/summary/cost_apply/list",
        method: "post",
        params,
        data
    })  
}
//应收款汇总
export function account_receivable_list(params,data) {
    return request({
        url: "/summary/account_receivable/list",
        method: "get",
        params,
        data
    })  
}
//柴油库存汇总
export function oil_list(params,data) {
    return request({
        url: "/summary/oil/list",
        method: "get",
        params,
        data
    })  
}
//运输汇总
export function driverbookSummary(data,pageNum,pageSize,year,month) {
    return request({
        url: `/driverbook/list/summary?pageNum=${pageNum}&pageSize=${pageSize}&year=${year}&month=${month}`,
        method: "get",
        data
    })  
}
//进销存汇总 - 进销存汇总查询
export function jxcsummaryList(params,data) {
    return request({
        url: "/jxcsummary/list",
        method: "get",
        params,
        data
    })  
}
//进销存汇总 - 进销存汇总保存
export function jxcsummarySave(params,data) {
    return request({
        url: "/jxcsummary/save",
        method: "post",
        params,
        data
    })  
}
//进销存汇总 - 进销存汇总更新
export function jxcsummaryUpdate(params,data) {
    return request({
        url: "/jxcsummary/update",
        method: "post",
        params,
        data
    })  
}